import React, { useEffect, useState } from 'react'
import { MainLayout } from 'views/layouts/'
import { useLocation } from 'react-router-dom'
import { userSelector } from 'ducks/user'
import { useSelector } from 'react-redux'
import { Container, RowContainer, InfoUserContainer, InfoColumn, CardInfo, ReportContainer } from './styled'
import { BackButton } from 'views/components/UI/Buttons'
import { H2, H5, H4, H3, P, SubtitleBold } from 'views/components/UI/Text'
import { fetchGetUserProcessAction } from './services/fetch_user_detail_process'
import { handleFetchError } from './constants'
import { UserData, ProcessData } from './store/entities'
import CardTypeTest from 'views/components/Cards/TestType'
import skillIcon from 'assets/images/icon-skills-card.png'
import betesaIcon from 'assets/images/icon-betesa-card.png'
import test360Icon from 'assets/images/icon-test360-card.png'
import { orderTestsByProcess } from 'utils/common'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import ModalLoader from 'views/components/UI/ModalLoader'
import { useNotification } from 'lib/context/notification.context'

const EvaluatedUserDetail = () => {
  // Función para validar si una cadena es un UUID
  const isUUID = (str: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return uuidRegex.test(str)
  }
  const { t } = useTranslation()
  const location = useLocation()
  const userId = location.state?.userId
  const processId = location.state?.processId[0] || location.state?.processId
  const { companyId } = useSelector(userSelector)
  const { getError, getSuccess } = useNotification()

  const [dataUser, setDataUser] = useState<UserData | null>(null)
  const [dataProcess, setDataProcess] = useState<ProcessData | null>(null)
  const [tests, setTests] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchDataUser = () => {
      setLoading(true)
      fetchGetUserProcessAction(userId, processId)
        .then((response) => {
          if (response) {
            setDataUser(response.user_detail)
            setDataProcess(response.companies_history.filter((item: any) => item.company_id === companyId))
            setTests(orderTestsByProcess(response.tests as any))
            setLoading(false)
          } else {
            throw new Error('Invalid response or missing user detail')
          }
        })
        .catch((error) => {
          handleFetchError(error)
          setLoading(false)
        })
    }
    fetchDataUser()
  }, [userId, processId, companyId])

  const renderProcessInfo = () => {
    if (dataProcess && Array.isArray(dataProcess)) {
      return dataProcess.map((item: any, index: number) => (
        <RowContainer style={{ gap: '0' }} key={`dataprocess-key-${index}`} margin="2px 0px">
          <SubtitleBold margin="0" style={{ fontWeight: '400' }}>
            {item.process_name} -
          </SubtitleBold>
          <SubtitleBold margin="0">{item.company_name}</SubtitleBold>
        </RowContainer>
      ))
    } else if (dataProcess) {
      return (
        <RowContainer margin="2px 0px">
          <P>{dataProcess.process_name} -</P>
          <P margin="0px 2px 0px 0px" weight={700}>
            {dataProcess.company_name}
          </P>
        </RowContainer>
      )
    } else {
      return <p>No hay procesos disponibles</p>
    }
  }

  const handleCopyActivationLink = async () => {
    if (!dataUser?.activation_link) {
      return
    }

    try {
      await navigator.clipboard.writeText(dataUser.activation_link)
      getSuccess('Link de activacion copiado')
    } catch (error) {
      getError('No fue posible copiar el link de activacion')
    }
  }

  return (
    <MainLayout>
      {!loading ? (
        <Container>
          <div>
            <H2 margin="1.5% 1.3%">Espacio de evaluado {dataUser?.user_name}</H2>
          </div>
          <InfoUserContainer>
            <InfoColumn>
              <CardInfo>
                <H5 margin="8px 0px">Datos personales</H5>
                <RowContainer margin="8px 0px">
                  <P margin="0px 6px 0px 0px" weight={700}>
                    Nombre completo:
                  </P>
                  <P>{dataUser ? dataUser.user_name : ''}</P>
                </RowContainer>
                <RowContainer margin="2px 0px">
                  <P weight={700} margin="0px 6px 0px 0px">
                    {' '}
                    Fecha de nacimiento:{' '}
                  </P>
                  <P>
                    {dataUser?.user_birth_date}
                    {` (${dayjs().diff(dayjs(dataUser?.user_birth_date, 'DD/MM/YYYY'), 'year')}) años`}
                  </P>
                </RowContainer>
                <RowContainer margin="2px 0px">
                  <P weight={700} margin="0px 6px 0px 0px">
                    Documento de identidad:
                  </P>
                  <P>{dataUser ? (isUUID(dataUser.user_document) ? 'N/A' : dataUser.user_document) : ''}</P>
                </RowContainer>
                {dataUser?.activation_link && (
                  <div style={{ marginTop: '16px' }}>
                    <P weight={700} margin="0px 0px 8px 0px">
                      Link de activacion:
                    </P>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        padding: '12px',
                        border: '1px solid #D9E6EF',
                        borderRadius: '8px',
                        backgroundColor: '#F7FBFD',
                      }}
                    >
                      <P
                        margin="0px"
                        style={{
                          wordBreak: 'break-all',
                          color: '#2D749C',
                        }}
                      >
                      {/*dataUser.activation_link*/} 
                      </P>
                      <div>
                        <button
                          type="button"
                          onClick={handleCopyActivationLink}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            color: '#2D749C',
                            cursor: 'pointer',
                            padding: '0px',
                            fontWeight: 700,
                          }}
                        >
                          Copiar link
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </CardInfo>
            </InfoColumn>
            <InfoColumn>
              <CardInfo>
                <H4 style={{ marginBottom: 20 }}>Procesos a los que pertenece</H4>
                {renderProcessInfo()}
              </CardInfo>
            </InfoColumn>
          </InfoUserContainer>
          <ReportContainer>
            <H3 margin="10px 0px">Pruebas realizadas</H3>
            {tests && tests.length > 0 ? (
              tests.map((process: any, index: number) => {
                return (
                  <div key={`user-detail-${index}`}>
                    <SubtitleBold fontSize="1.5rem">{process.process_name}</SubtitleBold>
                    <RowContainer margin="2px 0px">
                      {process.tests.map((test: any, indexItem: number) => {
                        const CardToRender =
                          test.category_name === 'Betesa Premium' ? (
                            <CardTypeTest
                              key={`user-detail-process-${indexItem}`}
                              link="/user-test-detail-talents/"
                              params={{
                                testId: test.test_id,
                                userName: dataUser?.user_name || '',
                                userId,
                                companyId,
                                processId,
                                language: test.language,
                              }}
                              title="Betesa"
                              image={betesaIcon}
                              disabled={test.domination === null}
                            />
                          ) : test.category_name === 'Competencias' ? (
                            <CardTypeTest
                              key={`user-detail-process-${indexItem}`}
                              link="/user-test-detail-skills/"
                              params={{
                                userId,
                                testId: test.test_id,
                                userName: dataUser?.user_name,
                                companyId,
                                completed: test.completed_test,
                              }}
                              title={t('global.common.skillText')}
                              image={skillIcon}
                              disabled={!test.completed_test}
                            />
                          ) : test.category_name === 'Prueba360' ? (
                            <CardTypeTest
                              key={`user-detail-process-${indexItem}`}
                              link="/user-test-detail-360/"
                              params={{
                                userId,
                                testId: test.test_id,
                                userName: dataUser?.user_name,
                                companyId,
                                completed: test.completed_test,
                                userTestId: test.user_test_id,
                              }}
                              title={t('global.common.threeSixtyText')}
                              image={test360Icon}
                            />
                          ) : null
                        return CardToRender
                      })}
                    </RowContainer>
                  </div>
                )
              })
            ) : (
              <P>Este usuario no ha presentado ninguna prueba</P>
            )}
            <BackButton style={{ marginTop: '60px' }} onClick={() => window.history.back()} />
          </ReportContainer>
        </Container>
      ) : (
        <ModalLoader isLoading={loading} />
      )}
    </MainLayout>
  )
}

export default EvaluatedUserDetail
